import { render, staticRenderFns } from "./GarbageRemoval.vue?vue&type=template&id=3e651ac0&"
import script from "./GarbageRemoval.vue?vue&type=script&lang=js&"
export * from "./GarbageRemoval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports